import React, { useState } from 'react';
import axios from 'axios';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/request-password-reset`, { email });
      setMessage('Als dit e-mailadres bekend is, zijn de resetinstructies verzonden.');
    } catch (err) {
      console.error(err);
      setError('Er is een fout opgetreden bij het versturen van de instructies.');
    } finally {
      setLoading(false);
    }
  };
return (
  <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light bg-gradient">
    <div className="shadow rounded-4 p-4 bg-white form-container-custom" style={{ width: '100%', maxWidth: '450px' }}>
      <h2 className="text-center mb-4 text-primary">Wachtwoord vergeten</h2>
      <form onSubmit={handleForgotPassword}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">E-mailadres</label>
          <input
            id="email"
            type="email"
            className="form-control"
            placeholder="Vul uw e-mailadres in"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        
        {message && <div className="alert alert-success mb-3">{message}</div>}
        {error && <div className="alert alert-danger mb-3">{error}</div>}

        <div className="d-grid mb-3">
          <button 
            type="submit" 
            className="btn btn-primary py-2"
            disabled={loading}
          >
            {loading ? 'Versturen...' : 'Verstuur instructies'}
          </button>
        </div>
      </form>
    </div>
  </div>
);
};

export default ForgotPassword;
